import { Filter } from '../../models';

export const allFilter: Filter[] = [
  /*
  Topic is currently not being set properly for news... removing until it is fixed at a later stage
  {
    title: 'Topic',
    field: 'topic',
    metadataField: 'topic',
    options: [
      {
        title: 'Agriculture, environment and sustainability',
        value: ['Agriculture, environment and sustainability', 'Environment'],
      },
      { title: 'Architecture and construction', value: 'Architecture and construction' },
      {
        title: 'Arts and creative industries',
        value: ['Arts and creative industries', 'Art and Design', 'Technology'],
      },
      {
        title: 'Business, innovation, management and law',
        value: 'Business, innovation, management and law',
      },
      {
        title: 'Culture, society and indigenous education',
        value: ['Culture, society and Indigenous Education', 'Society and culture'],
      },
      {
        title: 'Engineering, mining and surveying',
        value: ['Engineering, mining and surveying', 'Technology', 'Environment'],
      },
      { title: 'Health', value: 'Health' },
      { title: 'Information technology', value: ['Information technology', 'Technology'] },
      {
        title: 'Physical sciences, geoscience and mathematics',
        value: ['Physical sciences, geoscience and mathematics', 'Space and physics'],
      },
    ],
  },*/
  {
    title: 'Content type',
    field: 'content_type.enum',
    metadataField: 'content_type',
    options: [
      { title: 'Course', value: 'Course', metadataValue: 'course' },
      { title: 'Event', value: 'Event', metadataValue: 'event' },
      { title: 'News', value: 'News', metadataValue: 'news' },
      { title: 'Page', value: 'Page', metadataValue: 'page' },
      { title: 'PDF', value: 'PDF', metadataValue: 'pdf' },
      { title: 'People', value: 'People', metadataValue: 'people' },
      { title: 'Podcast', value: 'Podcast', metadataValue: 'podcast' },
    ],
  },
];
